"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = exports.configDefaults = void 0;var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));function _interopRequireDefault(e) {return e && e.__esModule ? e : { default: e };}

var configDefaults = exports.configDefaults = {
  nui: {
    assets: {
      app: {
        useCDN: {
          value: false
        },
        path: {
          value: '/static'
        }
      },
      cdn: {
        url: {
          value: '//static.concursolutions.com'
        }
      }
    },
    DRCListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    jouleListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    manage: {
      configurations: {
        listingId: {
          value: '',
          clientExposed: true,
          useDefault: true
        },
        url: {
          value: '',
          clientExposed: true,
          useDefault: true
        }
      },
      partnerConfig: {
        scriptSrc: {
          value: '',
          clientExposed: true,
          useDefault: true
        },
        integrity: {
          value: '',
          clientExposed: true,
          useDefault: true
        }
      }
    },
    apiGateway: {
      browser: {
        url: {
          value: '',
          clientExposed: true,
          useDefault: true
        }
      }
    },
    log: {
      application: {
        value: 'appcenter-web',
        useDefault: true
      },
      roletype: {
        value: 'appc',
        useDefault: true
      },
      version: {
        value: '1.0.0',
        useDefault: true
      }
    },
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    categoryDropdownThreshold: {
      value: 20,
      clientExposed: true,
      useDefault: true
    },
    endorsedCategoryEnabled: {
      value: true,
      clientExposed: true,
      useDefault: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    },
    x509: {
      key: {
        value: '',
        useDefault: true
      },
      cert: {
        value: '',
        useDefault: true
      }
    },
    // NUI_ENABLEINCOMPLETEDNFCONNECTIONBLOCKING
    enableIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    // NUI_FORCEINCOMPLETEDNFCONNECTIONBLOCKING
    forceIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    disallowConnectList: {
      value: '',
      clientExposed: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://rqa3.nonprod.cnqr.tech',
    clientExposed: true
  },
  port: 3000,
  logger: {
    category: 'Web-API'
  },
  cookie_consent: {
    value: false,
    useDefault: true,
    clientExposed: true
  }
};var _default = exports.default =

(0, _nuiConfig.default)(configDefaults);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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